import React from "react";
import { Link } from "react-router-dom";
import "./SupportPage.css";

export default function SupportPage() {
  return (
    <main className="support-page">
      <section className="support-hero">
        <div className="support-hero-content">
          <span className="support-eyebrow">Custom Roam Support</span>
          <h1>Need help?</h1>
          <p>
            We’re here to help with Roam Share, itinerary planning, account
            questions, and technical issues.
          </p>

          <a
            className="support-primary-button"
            href="mailto:support@customroam.com"
          >
            Email Support
          </a>
        </div>
      </section>

      <section className="support-content">
        <div className="support-intro-card">
          <h2>Contact us</h2>
          <p>
            Email us at{" "}
            <a href="mailto:support@customroam.com">
              support@customroam.com
            </a>
            .
          </p>
          <p>
            We aim to respond to support requests within 24–48 business hours.
          </p>
        </div>

        <div className="support-grid">
          <article className="support-card">
            <div className="support-icon" aria-hidden="true">
              🌍
            </div>
            <h2>Roam Share</h2>
            <ul>
              <li>Sharing travel photos and videos</li>
              <li>Creating, editing, or deleting posts</li>
              <li>Likes, comments, followers, and profiles</li>
              <li>Reporting users, posts, or comments</li>
              <li>Community and content questions</li>
            </ul>
          </article>

          <article className="support-card">
            <div className="support-icon" aria-hidden="true">
              ✈️
            </div>
            <h2>Trip planning</h2>
            <ul>
              <li>Generating personalized itineraries</li>
              <li>Saving and managing itineraries</li>
              <li>Opening or saving shared itinerary links</li>
              <li>Creating and managing bucket lists</li>
              <li>General trip-planning questions</li>
            </ul>
          </article>

          <article className="support-card">
            <div className="support-icon" aria-hidden="true">
              👤
            </div>
            <h2>Account and security</h2>
            <ul>
              <li>Login or signup problems</li>
              <li>Email verification and password reset</li>
              <li>Updating profile or account information</li>
              <li>Deleting your account</li>
              <li>Privacy and security questions</li>
            </ul>
          </article>

          <article className="support-card">
            <div className="support-icon" aria-hidden="true">
              📱
            </div>
            <h2>Technical support</h2>
            <ul>
              <li>App crashes or unexpected errors</li>
              <li>Performance or loading issues</li>
              <li>Problems uploading photos or videos</li>
              <li>Notification issues</li>
              <li>Feature feedback and suggestions</li>
            </ul>
          </article>
        </div>

        <section className="support-details-card">
          <h2>Help us resolve your issue faster</h2>
          <p>When contacting support, please include:</p>

          <ul>
            <li>Your Custom Roam account email address</li>
            <li>Your device model</li>
            <li>Your operating system and version</li>
            <li>A brief description of what happened</li>
            <li>Screenshots, when helpful</li>
          </ul>
        </section>

        <section className="support-links-section">
          <h2>Helpful links</h2>

          <div className="support-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms &amp; Conditions</Link>
            <Link to="/about-us">About Us</Link>
          </div>
        </section>

        <section className="support-closing">
          <h2>Our commitment</h2>
          <p>
            Custom Roam is committed to providing a reliable place where
            travelers can discover and share real experiences through Roam
            Share while planning personalized journeys with confidence.
          </p>
          <p>Thank you for being part of the Custom Roam community.</p>
        </section>
      </section>
    </main>
  );
}